import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppButton } from '@/components'
import { useAuthPreferencesStore } from '@/store'
import { useAuthScopedStore } from '@/store/scoped'

export const ContinueWithPhoneNumber: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const setIdentificationMethod = useAuthScopedStore(
    (state) => state.setIdentificationMethod,
  )
  const setAuthPreferences = useAuthPreferencesStore(
    (state) => state.setAuthPreferences,
  )

  const handlePress = () => {
    setIdentificationMethod('phone')
    setAuthPreferences({
      signInMethod: 'phone',
    })

    navigate('/auth/identifier/with-phone')
  }

  return (
    <AppButton
      label={t('form:actions.continueWith', {
        authMethod: t('common:phoneNumber'),
      })}
      onClick={handlePress}
      type="secondaryGrayDark"
      iconName="phone"
      iconSize={24}
      iconGap={12}
      isDefaultIconColor
    />
  )
}
